bcn.updateHash = (function () {
  'use strict';

  return {
    update: function(hash) {
      if(history.pushState) {
        history.pushState(null, null, hash);
      }
      else {
        location.hash = hash;
      }
    }
  };

})();
